/**
 * Content-Design-authored copy for the /sign-in/check-email route (design
 * state 1.2, TG-43, Content Design Agent mandatory per the constitution's
 * trigger table for user-facing text).
 *
 * Every string below is copied byte for byte from AC-22 in
 * `specs/features/m1-magic-link-authentication-session/product-spec.md` —
 * no developer-drafted wording, no lorem, no placeholder. `helpLine` is the
 * AC-29 help line shown on views for states 1.1 to 1.4.
 *
 * This view's rendered body must be byte-identical whether the submitted
 * address matched one renewal, several, none, only revoked access, or
 * reached its request cap (AC-22) — nothing here varies by outcome, and
 * there is deliberately no field or branch that could make it vary. It
 * never names, lists or counts renewals, and shows no resend action.
 *
 * `linkValidityStatement` carries the static "20 minutes" text ADR-20261008
 * -echd and AC-30 require: no endpoint, no request, no configuration read
 * at render time. `tests/api/test_link_validity_copy_matches_config.py`
 * (TG-43's companion test group) parses this exact string against every
 * tier's `MAGIC_LINK_TOKEN_VALIDITY_MINUTES` — do not reword "20 minutes"
 * here without updating that parse target.
 *
 * `matchedStatement` and `linkValidityStatement` were refreshed by TG-5
 * (m1-magic-link-portal-refresh) to match H2's own state 1.2 copy byte for
 * byte (design_handoff_renewals_portal_H2/screens/01-PortalEntry-
 * MagicLink.dc.html), which added one sentence to each over this file's
 * prior, pre-H2 wording — the "20 minutes" parse target above is
 * unaffected, since it sits in the same place in the amended sentence.
 */
export const checkEmailContent = {
  heading: "Check your email",

  matchedStatement:
    "If the email address you entered is linked to a renewal, we have sent a sign-in link to it. " +
    "The email comes from Foundation Risk Partners with the subject “Your sign-in link”.",
  linkValidityStatement:
    "The link works once and expires after 20 minutes. It can take a few minutes to arrive, so check your spam or junk folder if you cannot see it.",

  resendSubHeading: "Haven’t received it?",
  resendCheckStatement: "Check you used the address your renewal email was sent to.",
  reenterEmailActionLabel: "Enter your email address again",

  helpLine: "Need help? Contact your Account Manager.",
} as const;
